export const PDF_URL="https://j4kx88rxl8.execute-api.ap-south-1.amazonaws.com/local/getPdf"